import styled from 'styled-components';

export const SwitchContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.two};
`;
